module.exports = __webpack_public_path__ + "img/thumb_36.f1d70b03.jpg";